import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { PotentialClientOrigin } from 'src/app/models/potential-client.interface';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgxDropzoneChangeEvent, NgxDropzoneModule } from 'ngx-dropzone';

@Component({
  selector: 'app-import-potential-clients-dialog',
  templateUrl: './import-potential-clients-dialog.component.html',
  styleUrls: ['./import-potential-clients-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatHint,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatIcon,
    NgxDropzoneModule,
  ],
})
export class ImportPotentialClientsDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  private api = inject(ApiService);
  dialogRef = inject(MatDialogRef<ImportPotentialClientsDialogComponent>);

  form: FormGroup = this.fb.group({
    origin_id: [null, Validators.required],
  });

  origins: PotentialClientOrigin[] = [];
  files: File[] = [];
  importing = false;
  error_message: string | null = null;

  ngOnInit(): void {
    this.api.getPotentialClientOrigins().subscribe(data => {
      this.origins = Array.isArray(data?.data) ? data.data : [];
    });
  }

  get selectedOrigin(): PotentialClientOrigin | null {
    const id = this.form.value.origin_id;
    return this.origins.find(o => o.id === id) ?? null;
  }

  get supportsImport(): boolean {
    return this.selectedOrigin?.slug === 'apollo';
  }

  onSelect(event: NgxDropzoneChangeEvent) {
    this.files = event.addedFiles.slice(0, 1);
    this.error_message = null;
  }

  onRemove(file: File) {
    this.files = this.files.filter(f => f !== file);
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (!this.form.valid || !this.supportsImport || this.files.length === 0 || this.importing) {
      return;
    }

    this.importing = true;
    this.error_message = null;

    this.api.importPotentialClients(this.form.value.origin_id, this.files[0]).subscribe({
      next: result => {
        this.importing = false;
        this.dialogRef.close(result);
      },
      error: err => {
        this.importing = false;
        this.error_message = err?.error?.error ?? err?.error?.message ?? 'No se pudo importar el fichero.';
      },
    });
  }
}
